import LandingPage from 'views/public/landing-page/landing-page';

export default LandingPage;
